export default __webpack_public_path__ + "static/media/by_12.6a91d8c7.mp3";